import Header from './components/Header';
import HeroSection from './components/HeroSection';
import FaqSection from './components/FaqSection';
import RankingSection from './components/RankingSection';
import CarouselSection from './components/CarouselSection';
import AppSection from './components/AppSection';
import UpdatesSection from './components/UpdatesSection';
import ContactSection from './components/ContactSection';
import CardsSection from './components/CardsSection';
import CommentsSection from './components/CommentsSection';
import MediaSection from './components/MediaSection';
import FeaturesSection from './components/FeaturesSection';
import AboutSection from './components/AboutSection';
import TopicsSection from './components/TopicsSection';
import IndexSection from './components/IndexSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <FaqSection />
        <RankingSection />
        <CarouselSection />
        <AppSection />
        <UpdatesSection />
        <ContactSection />
        <CardsSection />
        <CommentsSection />
        <MediaSection />
        <FeaturesSection />
        <AboutSection />
        <TopicsSection />
        <IndexSection />
      </main>
      <Footer />
    </>
  );
}